import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "./DeleteModal.css";

import { toast } from "react-toastify";
import { dispatcher } from "../../store/storeHelpers";
import {
  TRACTOR_DELETE_SUBROW,
  AGGREGATE_DELETE_SUBROW,
  FIVE_M_DELETE_SUBROW,
  TRANSPORTER_DELETE_ROW,
  ARRIVAL_DELETE_ROW,
  CONTAINER_DELETE_ROW,
  VGM_DELETE_ROW,
  TRACTOR_ETA_DELETE_ROW,
  AGGREGATE_ETA_DELETE_ROW
} from "../../store/ActionTypes";
import moment from "moment";
import { updateTractorShipment, uploadTractorBookingDocument, viewSIDoc } from "../../services/tractorDataService";
import { updateAggregateShipment,getAggregateDailyContainerPlanning } from "../../services/aggregateDataService";
import {updateFiveMShipment,getFiveMDailyContainerPlanning } from "../../services/fiveMDataService";
import {
  // deleteTransporterDataTractor,
  // deleteTransporterDataAggregate,
  // deleteTransporterDataFiveM,
  deleteAllTransporterData,
} from "../../services/TransporterDataService";
import {
  // deleteContainerMasterDataTractor,
  // deleteContainerMasterDataAggregate,
  // deleteContainerMasterDataFiveM,
  deleteAllContainerMasterData,
} from "../../services/ContainerMasterService";
import {
  deleteAllVGMData,
  // deleteVGMDataAggregate,
  // deleteVGMDataFiveM,
  // deleteVGMDataTractor,
} from "../../services/VGMService";
import { filter } from "lodash";
import { getUser } from "../../services/authService";
import { getDailyContainerPlanningAB } from "../../services/tractorDataService";
import * as actionTypes from "../../store/ActionTypes"
import { tractorDataCreatorForStore, aggregateDataCreatorForStore, fiveMDataCreatorForStore } from "../../utils/dataFilter";


function DeleteModalDocument({
  show,
  hide,
  dataType,
  showModal,
  Id,
  ColumnName,
  PreviousValue,
  Value,
  date,
  setCountData
}) {
  const [showDeleteProcess, setShowDeleteProcess] = useState("Yes");

  let counterLabel = []
  let counterValue = {
    Booked: 0,
    Pending: 0,
    Approved: 0,
    Cancelled: 0,
    Not_Booked: 0,
    Hold:0,
  }

  const yesClickHandler = async () => {
    if (dataType === "Tractor")
    {
      try {
        await updateTractorShipment({
          DailyContainerPlanningId: Id,
          ColumnName: ColumnName,
          Value: Value,
          PreviousValue: PreviousValue,
        });
        const response = await getDailyContainerPlanningAB(
          moment(date).format("YYYY-MM-DD")
        );
        
        dispatcher(actionTypes.TRACTOR_BOOKING_LOADED, []);
        dispatcher(
          actionTypes.TRACTOR_BOOKING_LOADED,
          tractorDataCreatorForStore(response.data.Resultset1)
        );
        for (let i = 0; i < response.data.Resultset2.length; i++) {
          counterLabel.push(response.data.Resultset2[i]["STATUS"])
          if(response.data.Resultset2[i]["STATUS"] === "Booked"){
            counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
            counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Pending"){
            counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Approved"){
            counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
            counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Hold"){
            counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
          }
        }
        setCountData({label : counterLabel, counterData : counterValue})
        toast.success("Booking document deleted");

      } catch (error) {
        toast.error("Unable to delete booking document");
      }
    };
    
    if (dataType === "Aggregate")
    {
      try {
        await updateAggregateShipment({
          DailyContainerPlanningAggregateId:Id,
          ColumnName: ColumnName,
          Value: Value,
          PrevVal: PreviousValue,
        })
        const response = await getAggregateDailyContainerPlanning(
          moment(date).format("YYYY-MM-DD")
        );
        dispatcher(
          actionTypes.AGGREGATE_BOOKING_LOADED,[]
        );
        dispatcher(
          actionTypes.AGGREGATE_BOOKING_LOADED,
          aggregateDataCreatorForStore(response.data.Resultset1)
        );
        for (let i = 0; i < response.data.Resultset2.length; i++) {
          counterLabel.push(response.data.Resultset2[i]["STATUS"])
          if(response.data.Resultset2[i]["STATUS"] === "Booked"){
            counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
            counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Pending"){
            counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Approved"){
            counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
            counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Hold"){
            counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
          }
        }
        setCountData({label : counterLabel, counterData : counterValue})
        // setShowBookUpdate(true)
        toast.success("Booking document deleted");
      } catch (error) {
        toast.error("Unable to delete booking document");
      }
    }
    if (dataType === "5M")
    {

      try {
        await updateFiveMShipment({
          DailyContainerPlanning5MId: Id,
          ColumnName: ColumnName,
          Value: Value,
          PrevVal: PreviousValue,
        })
        const response = await getFiveMDailyContainerPlanning(
          moment(date).format("YYYY-MM-DD")
        );
        dispatcher(
          actionTypes.FIVE_M_BOOKING_LOADED,[]
        );
        dispatcher(
          actionTypes.FIVE_M_BOOKING_LOADED,
          fiveMDataCreatorForStore(response.data.Resultset1)
        );
        for (let i = 0; i < response.data.Resultset2.length; i++) {
          counterLabel.push(response.data.Resultset2[i]["STATUS"])
          if(response.data.Resultset2[i]["STATUS"] === "Booked"){
            counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
            counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Pending"){
            counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Approved"){
            counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
            counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Hold"){
            counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
          }
        }
        setCountData({label : counterLabel, counterData : counterValue})
        // setShowBookUpdate(true)
        toast.success("Booking doc deleted");
      } catch (error) {
        toast.error("Unable to delete booking document");
      }
    };
  }

   

  return (
    <>
      <Modal
        show={show || showModal.status}
        centered
        className="DeleteModal"
        dialogClassName="deleteWidthClass"
        contentClassName="deleteHeightClass"
      >
        <Modal.Body>
          <div className="DeleteModal__container">
            <div className="DeleteModal__title">Alert</div>
            <div className="DeleteModal__description">
                {/* {showModal.msg} */}
                Are you sure you want to delete this record?
            </div>
            <div className="DeleteModal__Btn">
              <Button className="DeleteModal__noBtn" onClick={() => hide()}>
                No
              </Button>
              <Button
                className="DeleteModal__yesBtn"
                onClick={yesClickHandler}
                disabled={showDeleteProcess === "Deleting..."}
              >
                {showDeleteProcess}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default DeleteModalDocument;
